import { render, staticRenderFns } from "./ResultsQuizGroup.vue?vue&type=template&id=93199bb6"
import script from "./ResultsQuizGroup.vue?vue&type=script&lang=js"
export * from "./ResultsQuizGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports